import BaseObserver from './baseObserver';

export default class ChartModelObserver extends BaseObserver {
    public getObserveData(): Record<string, any> {
        const { operationFrame, operatingGraphicInfo, previewChange } = this.model;

        return {
            selected: this.model.selected,
            operationFrame,
            operatingGraphicInfo,
            previewChange,
        };
    }
}

export class SubChartModelObserver extends BaseObserver {}
